<app-status-sidebar
  [itemId]="issueId()"
  [config]="issueConfig"
  [service]="issueService"
  [updateMethod]="'updateIssue'"
  [getDetailsMethod]="'getSingleIssue'"
  [refreshTrigger]="refreshTrigger()"
></app-status-sidebar>
